import {
  CREATE_LISTING_REQUEST,
  CREATE_LISTING_SUCCESS,
  CREATE_LISTING_FAILURE,
  FETCH_LISTINGS_REQUEST,
  FETCH_LISTINGS_SUCCESS,
  FETCH_LISTINGS_FAILURE,
  UPDATE_LISTING_REQUEST,
  UPDATE_LISTING_SUCCESS,
  UPDATE_LISTING_FAILURE,
  DELETE_LISTING_REQUEST,
  DELETE_LISTING_SUCCESS,
  DELETE_LISTING_FAILURE,
} from "../actions/types";

const initialState = {
  listings: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    size: 10,
    pages: 1,
  },
};

export default function productListingReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_LISTINGS_REQUEST:
    case CREATE_LISTING_REQUEST:
    case UPDATE_LISTING_REQUEST:
    case DELETE_LISTING_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_LISTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        listings: action.payload.data || [],
        pagination: {
          total: action.payload.total,
          page: action.payload.page,
          size: action.payload.size,
          pages: action.payload.pages,
        },
      };

    case CREATE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        listings: [action.payload, ...state.listings],
      };

    case UPDATE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        listings: state.listings.map((l) =>
          l.listing_id === action.payload.listing_id
            ? action.payload
            : l
        ),
      };

    case DELETE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        listings: state.listings.filter(
          (l) => l.listing_id !== action.payload
        ),
      };

    case CREATE_LISTING_FAILURE:
    case FETCH_LISTINGS_FAILURE:
    case UPDATE_LISTING_FAILURE:
    case DELETE_LISTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}